<template>
  <div class="pa-3 pb-0" style="max-height: 80vh; overflow-y: scroll">
    <!-- isType == 'Sentence' and key == Title | Structure-->
    <v-row
      class="px-4"
      v-if="
        (activeFieldExpression.key == 'Title' ||
          activeFieldExpression.key == 'Structure') &&
          isType == 'Sentence'
      "
      :key="isType"
    >
      <h4 class="mr-12 mt-2">型式</h4>
      <v-select
        class="ml-8"
        style="max-width: 124px"
        :items="
          activeFieldExpression.key == 'Title' ? typeTitle : typeStructure
        "
        outlined
        hide-details
        dense
        v-model="activeFieldExpression.isType"
        item-value="value"
      />
    </v-row>
    <!-- isType == 'Sentence' and key == Title | Structure-->
    <v-row
      class="px-4 my-4"
      v-if="
        (activeFieldExpression.key == 'Title' ||
          activeFieldExpression.key == 'Structure') &&
          isType == 'Sentence'
      "
    >
      <v-col class="pa-0 max-width-1 min-width-1">
        <h4>カラー選択</h4>
      </v-col>
      <v-col class="pa-0" style="max-width: 240px; display: contents">
        <div
          class="v-color-picker__color ml-3"
          v-for="(color, index) in colors"
          :key="`color-${index}`"
          @click="activeFieldExpression.color = color"
        >
          <div :style="{ background: color }">
            <i
              aria-hidden="true"
              v-show="activeFieldExpression.color == color"
              class="v-icon notranslate fas fa-check-circle theme--dark"
              style="font-size: 16px"
              :key="activeFieldExpression.color"
            ></i>
          </div>
        </div>
      </v-col>
      <v-dialog v-model="dialogColorPicker" width="300">
        <template v-slot:activator="{ on, attrs }">
          <!-- <v-btn icon small color="success" v-bind="attrs" v-on="on"> -->
          <v-icon
            small
            v-bind="attrs"
            color="success"
            class="pb-1 ml-5"
            v-on="on"
            >fas fa-plus</v-icon
          >
          <!-- </v-btn> -->
        </template>

        <v-card>
          <v-color-picker
            :swatches="swatches"
            hide-mode-switch
            v-model="swatchesPicker"
            mode="hexa"
            :key="`swatches-${swatches.length}`"
            show-swatches
          ></v-color-picker>
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" @click="handleAddColor" small>OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- isType == 'Sentence' and key == Title | Structure and activeFieldExpression.isType == 'TEXT'-->
    <v-row
      class="px-4"
      v-if="
        (activeFieldExpression.key == 'Title' ||
          (activeFieldExpression.key == 'Structure' &&
            activeFieldExpression.isType == 'TEXT')) &&
          isType == 'Sentence'
      "
    >
      <h4 class="mr-5 mt-2">データ入力 <span class="red--text">*</span></h4>
      <v-text-field
        v-model="activeFieldExpression.value.ja"
        outlined
        dense
        autofocus
        :error-messages="activeFieldExpressionErrors"
        @input="$v.activeFieldExpression.value.ja.$touch()"
        @blur="$v.activeFieldExpression.value.ja.$touch()"
      />
    </v-row>
    <v-row
      class="px-4"
      v-if="
        (activeFieldExpression.key == 'Title' ||
          (activeFieldExpression.key == 'Structure' &&
            activeFieldExpression.isType == 'TEXT')) &&
          isType == 'Sentence'
      "
    >
      <h4 class="mr-5 mt-2">
        データ入力（かな） <span class="red--text">*</span>
      </h4>
      <v-text-field
        v-model="activeFieldExpression.value.kana"
        outlined
        dense
        autofocus
        :error-messages="activeFieldExpressionErrors"
        @input="$v.activeFieldExpression.value.kana.$touch()"
        @blur="$v.activeFieldExpression.value.kana.$touch()"
      />
    </v-row>
    <!-- isType == 'Sentence' and key == Title | Structure and activeFieldExpression.isType == 'UNDERLINE'-->
    <v-row
      class="px-4"
      v-if="
        activeFieldExpression.key == 'Structure' &&
          activeFieldExpression.isType == 'UNDERLINE' &&
          isType == 'Sentence'
      "
    >
      <h4 class="mr-5 mt-2">データ入力</h4>
      <v-text-field
        v-model="activeFieldExpression.value.ja"
        outlined
        class="ml-3"
        dense
        autofocus
      />
      <h4 class="mr-5 mt-2">
        データ入力（かな） <span class="red--text">*</span>
      </h4>
      <v-text-field
        v-model="activeFieldExpression.value.kana"
        outlined
        dense
        autofocus
        :error-messages="activeFieldExpressionErrors"
        @input="$v.activeFieldExpression.value.kana.$touch()"
        @blur="$v.activeFieldExpression.value.kana.$touch()"
      />
    </v-row>
    <template v-if="activeFieldExpression.key == 'Example'">
      <div class="d-flex mb-5">
        <strong class="mt-1 mr-3">音声データ</strong>
        <audio id="Audio" :key="keyAudio" ref="audio">
          <source
            :src="
              activeFieldExpression.file
                ? activeFieldExpression.file.fileUrl
                : null
            "
            type="audio/mp3"
          />
          Your browser does not support the audio element.
        </audio>
        <v-btn
          color="warning"
          fab
          small
          height="25"
          width="25"
          style="margin-top: 3px"
          dark
          @click="play"
          v-if="
            activeFieldExpression.file && activeFieldExpression.file.fileUrl
          "
        >
          <v-icon size="15">fas fa-volume-up</v-icon>
        </v-btn>
        <v-spacer />
        <base-upload type="audio" v-model="activeFieldExpression.file">
          <span slot="activator">
            <v-btn small class="primary mr-1">{{ $t("FILE_SELECT") }}</v-btn>
          </span>
        </base-upload>
      </div>
    </template>
    <template
      v-if="
        activeFieldExpression.key == 'Explain' ||
          activeFieldExpression.key == 'Example' ||
          activeFieldExpression.key == 'Challenge'
      "
    >
      <v-row class="px-4" v-for="lang in language" :key="lang.key">
        <v-textarea
          :spellcheck="false"
          dense
          :auto-grow="true"
          outlined
          :rows="2"
          v-if="lang.key == 'ja'"
          :error-messages="activeFieldExpressionErrors"
          @input="$v.activeFieldExpression.value.ja.$touch()"
          @blur="$v.activeFieldExpression.value.ja.$touch()"
          v-model="activeFieldExpression.value[lang.key]"
        >
          <template v-slot:label>
            <span class="font-weight-bold mr-1">{{ lang.text }}</span>
            <span class="red--text" v-if="lang.key == 'ja'">*</span>
          </template>
        </v-textarea>
        <v-textarea
          :spellcheck="false"
          dense
          :auto-grow="true"
          outlined
          :rows="2"
          v-else-if="lang.key == 'kana'"
          :error-messages="activeFieldExpressionErrors"
          @input="$v.activeFieldExpression.value.kana.$touch()"
          @blur="$v.activeFieldExpression.value.kana.$touch()"
          v-model="activeFieldExpression.value[lang.key]"
        >
          <template v-slot:label>
            <span class="font-weight-bold mr-1">{{ lang.text }}</span>
            <span class="red--text" v-if="lang.key == 'kana'">*</span>
          </template>
        </v-textarea>
        <v-textarea
          :spellcheck="false"
          dense
          :auto-grow="true"
          outlined
          :rows="2"
          v-else-if="activeFieldExpression.key != 'Challenge'"
          v-model="activeFieldExpression.value[lang.key]"
        >
          <template v-slot:label>
            <span class="font-weight-bold mr-1">{{ lang.text }}</span>
          </template>
        </v-textarea>
      </v-row>
    </template>
    <v-row
      class="px-4 pb-3"
      v-if="activeFieldExpression.hasOwnProperty('hidden')"
    >
      <h4 class="mr-8 mt-1">表示</h4>
      <v-switch
        v-model="activeFieldExpression.hidden"
        hide-details
        class="mt-0"
      />
    </v-row>
  </div>
</template>

<script>
import mixin from "@/mixin";

export default {
  name: "Properties",
  mixins: [mixin.ValidateExpression],
  store: ["activeFieldExpression", "isType"], // Get the form data from Home
  watch: {
    activeFieldExpression: function() {
      this.$v.$reset();
    },
    "activeFieldExpression.file": function() {
      this.keyAudio++;
    },
    "activeFieldExpression.fileUrl": function() {
      this.keyAudio++;
    },
    "activeFieldExpression.color": function(val) {
      this.swatchesPicker = val;
    },
    dialogColorPicker: function() {
      this.swatchesPicker = this.activeFieldExpression.color;
    },
  },
  data() {
    return {
      language: [
        { text: "日本語", key: "ja" },
        { text: "日本語（かな）", key: "kana" },
        { text: "英語", key: "en" },
        { text: "中国語", key: "cn" },
        { text: "ベトナム語", key: "vn" },
        { text: "ベンガル語", key: "bn" },
        { text: "ポルトガル語", key: "pt" },
      ],
      colors: [
        "#69BE5B",
        "#F26B68",
        "#262626",
        "#2B62DF",
        "#8D2CE9",
        "#F9AC69",
        "#8B848F",
      ],
      swatches: [
        ["#69BE5B"],
        ["#F26B68"],
        ["#262626"],
        ["#00FFFF"],
        ["#0000FF"],
      ],
      swatchesPicker: "",
      typeTitle: [
        { text: "テキスト", value: "TEXT" },
        { text: "丸い四角", value: "ROUND_SQUARE" },
        { text: "円形", value: "CIRCLE" },
      ],
      typeStructure: [
        { text: "テキスト", value: "TEXT" },
        { text: "ボックス", value: "BOX" },
        { text: "下線", value: "UNDERLINE" },
      ],
      keyAudio: 0,
      dialogColorPicker: false,
    };
  },
  mounted() {
    this.swatchesPicker = this.activeFieldExpression.color;
    this.handleAddColor();
  },
  methods: {
    handleCheckValidate() {
      this.$v.$touch();
      return this.$v.$anyError;
    },
    play() {
      if (this.$refs.audio.paused) {
        this.$refs.audio.play();
      } else {
        this.$refs.audio.pause();
      }
    },
    handleAddColor() {
      const {
        _,
        colors,
        swatchesPicker,
        activeFieldExpression: { color },
      } = this;
      let res = _.find(colors, (e) => e == color);
      let resSelect = _.find(colors, (e) => e == swatchesPicker);
      let swatches = this.swatches.toString();
      if (!res || !resSelect) {
        this.activeFieldExpression.color = swatchesPicker;
        this.colors.push(swatchesPicker);
      }
      if (swatches.search(swatchesPicker) == -1) {
        this.activeFieldExpression.color = swatchesPicker;
        this.swatches.push([swatchesPicker]);
      }
      this.dialogColorPicker = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.properties__optionslist {
  margin-bottom: 5px;
  list-style: none;
  list-style-type: none;
}
.properties__optionsul {
  padding: 0;
}
</style>
<style scoped>
button:focus {
  outline: none;
}
.is-active {
  border: 2.2px solid #555;
}
</style>
